export default __webpack_public_path__ + "static/media/tutoring3.cde30cad.svg";